"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReferencePriceArticleType = void 0;
var ReferencePriceArticleType;
(function (ReferencePriceArticleType) {
    ReferencePriceArticleType["Kette"] = "ketten";
    ReferencePriceArticleType["Leitung"] = "leitungen";
})(ReferencePriceArticleType = exports.ReferencePriceArticleType || (exports.ReferencePriceArticleType = {}));
//# sourceMappingURL=ReferencePriceModel.js.map